var map = {
	"./atlanteans-empire.png": "cedd",
	"./carthaginians-empire.png": "e642",
	"./celts-empire.png": "7fef",
	"./egyptians-empire.png": "082e",
	"./greeks-empire.png": "6f5c",
	"./macedonians-empire.png": "9161",
	"./mauryans-empire.png": "4686",
	"./minoans-empire.png": "0634",
	"./olmecs-empire.png": "f3c4",
	"./persians-empire.png": "1d73",
	"./qin-empire.png": "d1e1",
	"./romans-empire.png": "ab45",
	"./scythians-empire.png": "15bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5e33";